import React from 'react';
import {Text, Icon, Button} from '@cloudaper/react';

const AppError = props => {
  const {
    handleSendLink,
    handleResendInvitation,
    handleResendWelcome,
    linkSent,
    type,
  } = props;

  switch (type) {
    case 'tokenExpiredInvitation':
      return (
        <div id="tokenExpiredInvitation" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              {linkSent === 'never' ? (
                <Text className="appHeading centeredText">
                  Vypršela platnost přihlašovacích údajů
                </Text>
              ) : (
                <>
                  <Text className="appHeading centeredText">
                    Pozvánka byla obnovena
                  </Text>

                  <br />
                  <Text className="centeredText cardBodyText">
                    Podívejte se do své schránky a&nbsp;klikněte na ověřovací
                    odkaz.
                  </Text>
                </>
              )}

              {linkSent === 'never' && (
                <div className="routeButtons">
                  <Button
                    kind="primary"
                    onClick={handleResendInvitation}
                    raised
                  >
                    Obnovit pozvánku
                  </Button>
                </div>
              )}

              {linkSent === 'once' && (
                <div className="routeButtons">
                  <Button
                    kind="primary"
                    onClick={handleResendInvitation}
                    raised
                  >
                    Poslat znovu
                  </Button>
                </div>
              )}

              {linkSent === 'twice' && (
                <>
                  <br />
                  <Text className="centeredText cardBodyText">
                    Možná došlo k dočasné chybě. Zkuste to prosím později, nebo
                    nás kontaktujte.
                  </Text>
                </>
              )}
            </div>
          </div>
        </div>
      );

    case 'tokenExpiredWelcome':
      return (
        <div id="tokenExpiredWelcome" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              {linkSent === 'never' ? (
                <Text className="appHeading centeredText">
                  Vypršela platnost přihlašovacích údajů
                </Text>
              ) : (
                <>
                  <Text className="appHeading centeredText">
                    Pozvánka byla obnovena
                  </Text>

                  <br />
                  <Text className="centeredText cardBodyText">
                    Podívejte se do své schránky a&nbsp;klikněte na ověřovací
                    odkaz.
                  </Text>
                </>
              )}

              {linkSent === 'never' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleResendWelcome} raised>
                    Obnovit pozvánku
                  </Button>
                </div>
              )}

              {linkSent === 'once' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleResendWelcome} raised>
                    Poslat znovu
                  </Button>
                </div>
              )}

              {linkSent === 'twice' && (
                <>
                  <br />
                  <Text className="centeredText cardBodyText">
                    Možná došlo k dočasné chybě. Zkuste to prosím později, nebo
                    nás kontaktujte.
                  </Text>
                </>
              )}
            </div>
          </div>
        </div>
      );

    case 'tokenExpired':
      return (
        <div id="tokenExpired" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              {linkSent === 'never' ? (
                <>
                  <Text className="appHeading centeredText">
                    Vypršela platnost přihlašovacích údajů
                  </Text>

                  <br />
                  <Text className="centeredText cardBodyText">
                    Nechte si na zadaný e-mail zaslat jiný odkaz, abyste mohli
                    založit další místnost.
                  </Text>
                </>
              ) : (
                <>
                  <Text className="appHeading centeredText">
                    Pozvánka byla obnovena
                  </Text>

                  <br />
                  <Text className="centeredText cardBodyText">
                    Podívejte se do své schránky a&nbsp;klikněte na ověřovací
                    odkaz.
                  </Text>
                </>
              )}

              {linkSent === 'never' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleSendLink} raised>
                    Obnovit pozvánku
                  </Button>
                </div>
              )}

              {linkSent === 'once' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleSendLink} raised>
                    Poslat znovu
                  </Button>
                </div>
              )}

              {linkSent === 'twice' && (
                <>
                  <br />
                  <Text className="centeredText cardBodyText">
                    Možná došlo k dočasné chybě. Zkuste to prosím později, nebo
                    nás kontaktujte.
                  </Text>
                </>
              )}
            </div>
          </div>
        </div>
      );

    case 'tokenRouteInvalid':
      return (
        <div id="tokenRouteInvalid" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              <Text className="appHeading centeredText">
                Přihlašovací údaje jsou neplatné
              </Text>

              <br />
              <Text className="centeredText cardBodyText">
                Zkopírovali jste odkaz správně?
              </Text>
            </div>
          </div>
        </div>
      );

    case 'tokenInvalid':
      return (
        <div id="tokenInvalid" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              <Text className="appHeading centeredText">
                Přihlašovací údaje jsou neplatné
              </Text>

              <br />
              <Text className="centeredText cardBodyText">
                Přejděte prosím na hlavní stránku a začněte znovu.
              </Text>

              <div className="routeButtons">
                <Button
                  kind="primary"
                  onClick={() => window.location.replace('/')}
                  raised
                >
                  Přejít na hlavní stránku
                </Button>
              </div>
            </div>
          </div>
        </div>
      );

    case 'roomAlreadyCreated':
      return (
        <div id="roomAlreadyCreated" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              {linkSent === 'never' ? (
                <>
                  <Text className="appHeading centeredText">
                    S tímto odkazem už byla místnost založena
                  </Text>

                  <br />
                  <Text className="centeredText cardBodyText">
                    Nechte si na zadaný e-mail zaslat jiný odkaz, abyste mohli
                    založit další místnost.
                  </Text>
                </>
              ) : (
                <>
                  <Text className="appHeading centeredText">
                    Nový odkaz byl odeslán
                  </Text>

                  <br />
                  <Text className="centeredText cardBodyText">
                    Podívejte se do své schránky a&nbsp;klikněte na ověřovací
                    odkaz.
                  </Text>
                </>
              )}

              {linkSent === 'never' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleSendLink} raised>
                    Odeslat nový odkaz
                  </Button>
                </div>
              )}

              {linkSent === 'once' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleSendLink} raised>
                    Poslat znovu
                  </Button>
                </div>
              )}

              {linkSent === 'twice' && (
                <>
                  <br />
                  <Text className="centeredText cardBodyText">
                    Možná došlo k dočasné chybě. Zkuste to prosím později, nebo
                    nás kontaktujte.
                  </Text>
                </>
              )}
            </div>
          </div>
        </div>
      );

    default:
      return (
        <div id="defaultError" className="appMain">
          <div className="appWrapper">
            <Text className="appConnectorCounter">
              <Icon large name="cross" />
            </Text>

            <div className="appContent">
              <Text className="appHeading centeredText">
                Někde se stala chyba
              </Text>

              <br />
              <Text className="centeredText cardBodyText">
                Zkuste to prosím později, nebo nás kontaktujte.
              </Text>
            </div>
          </div>
        </div>
      );
  }
};

export default AppError;
